export default {
      id: "pinterest-usage",
      viewBox: "0 0 18.824 24.351",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }